"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Plan_895 = void 0;
var Plan_895 = exports.Plan_895 = {
  planNumber: 895,
  kindOfCover: "Accident & GVE",
  externalName: "Imperial Cover (Accidental Injury and Illness)",
  coolingOffPeriod: true,
  gapOnly: true,
  dental: true,
  routineCare: false,
  emergencyBoarding: true,
  emergencyBoardingFees: "$1,000",
  petSpecies: ["FELINE", "CANINE"],
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "3834",
    "excessNo": 3834
  }],
  levelsOfCover: [80],
  staffOnly: false,
  staffLevelsOfCover: [],
  stepDownLevelsOfCover: [],
  stepDown: false,
  limits: {
    "ageLimits": {
      "minAgeDays": 55,
      "maxAgeDays": 3287,
      "displayValue": "Older than 8 weeks and younger than 9 years"
    },
    "annualLimit": {
      "amount": 14000,
      "formattedAmount": "$14,000",
      "displayValue": "$14,000"
    },
    "paralysisTick": "$1,000 sub-limit",
    "tickParalysis": "$1,000 sub-limit",
    "cruciateLigament": "$2,600 sub-limit",
    "consultationLimit": "$300 sub-limit",
    "consultationsAndVet": "$300 sub-limit",
    "consultationsAndVisits": "$300 sub-limit",
    "consultation": true,
    "dentalCareLimit": "$2,000",
    "emergencyBoardingFees": "$1,000",
    "emergencyBoardingLimit": "$1,000 sub-limit"
  },
  waitingPeriods: {
    "detailed": {
      "waitingPeriodMessages": ["30 days for general veterinary expenses.", "No waiting period for specified accidental injuries.", "No waiting period for routine care where selected.", "2 years for dental illness treatments where selected.", "No waiting period for emergency boarding."],
      "waitingPeriod": "30 days for general veterinary expenses.<br/>No waiting period for specified accidental injuries.<br/>No waiting period for routine care where selected.<br/>2 years for dental illness treatments where selected.<br/>No waiting period for emergency boarding.",
      "itemisedWaitingPeriods": {
        "generalVeterinaryExpenses": {
          "waitTime": "30 days",
          "label": "general veterinary expenses"
        },
        "specifiedAccidentalInjuries": {
          "waitTime": "No waiting period",
          "label": "specified accidental injuries"
        },
        "routineCare": {
          "waitTime": "No waiting period",
          "label": "routine care where selected"
        },
        "dental": {
          "waitTime": "2 years",
          "label": "dental illness treatments where selected"
        },
        "emergencyBoarding": {
          "waitTime": "No waiting period",
          "label": "emergency boarding"
        }
      }
    }
  },
  customCoverDetails: {
    "afterLifeCare": false,
    "alprazolam": false,
    "amitriptyline": false,
    "behaviouralAssessment": false,
    "behaviouralTherapy": false,
    "councilRegistration": false,
    "desexing": false,
    "essentialEuthanasia": false,
    "fleaControlDrugs": false,
    "fleaTickControlDrugs": false,
    "fleaWormDrugs": false,
    "groomingComplication": true,
    "heartWormDrugs": false,
    "intestinalWormDrugs": false,
    "jointSupplements": false,
    "microchipping": false,
    "prescriptionDiet": false,
    "trazodone": false,
    "vaccinationCat": false,
    "vaccinationDog": false,
    "coversIllness": true,
    "infectiousDisease": true,
    "ingestionOfForeignBodies": true
  },
  isBasePlan: true,
  addOns: ["dental"]
};
var _default = exports["default"] = {
  Plan_895: Plan_895
};